import { useEffect, useState } from 'react';
import { getPostalCode, POSTAL_CODE_EVENT } from '@/lib/postalCode';

export function usePostalCode() {
  const [postalCode, setPc] = useState(getPostalCode);
  useEffect(() => {
    const handler = (e) => setPc(e.detail || '');
    window.addEventListener(POSTAL_CODE_EVENT, handler);
    return () => window.removeEventListener(POSTAL_CODE_EVENT, handler);
  }, []);
  return postalCode;
}
